import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=69950a46&scoped=true"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./PageBreadcrumbs.vue?vue&type=style&index=0&id=69950a46&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69950a46",
  null
  
)

export default component.exports